@if (ppPoint) {
  <div
    class="point__control"
    [class.point__control--full]="ppFull"
    (click)="$event.stopPropagation()"
  >
    <div class="point__control-left" data-m-target="Point previous & next buttons">
      @if (isShowingRemindersFullScreen()) {
        <pp-button (ppAction)="back()" ppStyle="text">
          <pp-icon
            [ppSVG]="iconMap[EIconPath.ARROW_LEFT]"
            ppColor="primary-950"
            [ppDisplayContents]="true"
          />

          {{ 'back_to_point' | ppTranslate }}
        </pp-button>
      }
      @if (!isShowingRemindersFullScreen()) {
        <div class="pointControl__arrows">
          @if (!ppNew) {
            <div
              ppTooltip
              id="previousPointBtn_halfModal"
              class="point__control-btn"
              [ngClass]="{
                'point__control-btn--disabled': ppAttachmentUploading || !nextPointExists,
              }"
              ppTitle="Previous Point"
              (click)="prevPoint()"
              data-test="previousPointButton"
            >
              <pp-icon
                [ppSVG]="iconMap[EIconPath.ICON_MISC_UP_ARROW_24]"
                ppColor="grey-500"
                ppClass="setSize24"
              />
            </div>
          }
          @if (!ppNew && !isShowingRemindersFullScreen()) {
            <div
              ppTooltip
              id="nextPointBtn_halfModal"
              class="point__control-btn"
              [ngClass]="{
                'point__control-btn--disabled': ppAttachmentUploading || !nextPointExists,
              }"
              ppTitle="Next Point"
              (click)="nextPoint()"
              data-test="nextPointButton"
            >
              <pp-icon
                [ppSVG]="iconMap[EIconPath.ICON_MISC_DOWN_ARROW_24]"
                ppColor="grey-500"
                ppClass="setSize24"
              />
            </div>
          }
        </div>
      }
      @if (!ppNew && !isShowingRemindersFullScreen()) {
        <div class="pointControl__line"></div>
      }
      @if (ppPoint && hasWorkspaces && !ppNew && !isShowingRemindersFullScreen()) {
        <pp-point-seen-by class="hide--mobile" [ppSeenBy]="ppPointDetails?.viewersByIds" />
      }
    </div>
    <div class="point__control-right">
      <div class="pointControl__rightButtons">
        @if (!ppNew && ppDetailsFetched) {
          <div
            ppTooltip
            id="redFlag_halfModal"
            data-m-target="Point Flag Button"
            data-test="flagButton"
            class="point__control-btn point__control-btn--border"
            (click)="toggleFlag()"
            [ngClass]="{ 'point__control-btn--disabled': !canEditFlag }"
            [ppTitle]="
              ppPointDetails && ppPoint.flagged
                ? ('remove_flag' | ppTranslate)
                : ('add_flag' | ppTranslate)
            "
          >
            <pp-icon
              [ppSVG]="
                ppPoint.flagged
                  ? iconMap[EIconPath.ICON_ACTIVITIES_RED_FLAG_ACTIVATED_24]
                  : iconMap[EIconPath.ICON_ACTIVITIES_RED_FLAG_24]
              "
              [ppDisplayContents]="true"
            />
          </div>
        }
        @if (!ppNew && ppDetailsFetched) {
          <div
            ppTooltip
            data-test="subscribeButton"
            id="subscribe_halfModal"
            data-m-target="Subscribe To Point Button"
            class="point__control-btn point__control-btn--border"
            [class.point__control-btn--blue]="ppPointDetails?.pushNotificationsSubscription"
            [ppTitle]="
              ppPointDetails?.pushNotificationsSubscription
                ? 'Subscribed to point'
                : 'Subscribe to point'
            "
            (click)="toggleSubscription()"
          >
            <pp-icon
              ppClass="setSize24"
              [ppColor]="ppPointDetails?.pushNotificationsSubscription ? 'white' : 'grey-500'"
              [ppSVG]="
                ppPointDetails?.pushNotificationsSubscription
                  ? iconMap[EIconPath.ICON_MISC_BELL_PLUS_24]
                  : iconMap[EIconPath.ICON_MISC_BELL_24]
              "
            />
          </div>
        }
        @if (!ppFull || (ppFull && !ppNew)) {
          <div
            ppTooltip
            id="expandModalBtn_halfModal"
            data-m-target="Expand point button"
            data-test="expandCompressButton"
            class="point__control-btn point__control-btn--border"
            [ngClass]="{ 'point__control-btn--disabled': ppAttachmentUploading }"
            [ppTitle]="ppFull ? ('collapse_point' | ppTranslate) : ('expand_point' | ppTranslate)"
            (click)="toggleModal()"
          >
            <pp-icon
              [ppSVG]="
                ppFull
                  ? iconMap[EIconPath.ICON_MISC_CLOSE_ARROWS_24]
                  : iconMap[EIconPath.ICON_MISC_OPEN_24]
              "
              class="point__control-icon--animated"
              ppColor="grey-500"
              ppClass="setSize24"
            />
          </div>
        }
        @if (!ppNew && ppDetailsFetched) {
          <div
            ppTooltip
            [ppTitle]="'reminders' | ppTranslate"
            id="reminder_halfModal"
            data-test="reminderButton"
            data-m-target="Point Reminder Button"
            class="point__control-btn point__control-btn--border"
            (click)="viewReminders()"
          >
            <pp-icon
              ppClass="setSize24"
              ppColor="grey-500"
              [ppSVG]="iconMap[EIconPath.ICON_MISC_REMINDER_ICON_24]"
            />
          </div>
        }
        @if (isTimeline || isOverview) {
          <div
            ppTooltip
            id="openInSiteBtn_halfModal"
            data-m-target="Open point in site button"
            class="point__control-btn point__control-btn--border"
            [ngClass]="{ 'point__control-btn--disabled': ppAttachmentUploading }"
            [ppTitle]="'open_in_site' | ppTranslate"
            (click)="openInSite()"
            data-test="expandCompressButton"
          >
            <pp-icon [ppSVG]="iconMap[EIconPath.POINT_INTERACTION_OPEN_IN_SITE]" />
          </div>
        }
      </div>
      <pp-point-options
        [ppPointId]="ppPoint._id"
        [ppFull]="ppFull"
        [ppNew]="ppNew"
        [ppWorkspaceId]="ppPoint.workspaceRef.id"
      />
      <div class="pointControl__line pointControl__line--big"></div>
      <div
        ppTooltip
        id="closeModalBtn_halfModal"
        class="point__control-btn"
        [ngClass]="{ 'point__control-btn--disabled': ppAttachmentUploading }"
        [ppTitle]="'close_point' | ppTranslate"
        (click)="hide()"
        data-test="closePoint"
      >
        <pp-icon
          class="point__control-icon--close"
          id="closeModalBtn_icon"
          [ppSVG]="iconMap[EIconPath.INTERACTION_CLOSE]"
        />
      </div>
    </div>
  </div>
}
